// extracted by mini-css-extract-plugin
export default {"option":"SelectOptionContent-module__option--VDzE3","icon":"SelectOptionContent-module__icon--oZJcX","animatedBackground":"SelectOptionContent-module__animatedBackground--b9VDg"};